import Vue from 'vue';
import store from './../../store';

const GET_ALL_LISTS_URL = '/api/v1/user/lists/all';

const successAll = (response) => {
  store.dispatch('getAllLists', response.data);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// When the request fails
const failedAll = () => {
};

export default () => {
  const axiosOptions = {
    timeout: 5000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  // const queryinfo = {
  //   url: urltoquery,
  // };
  Vue.$http.get(GET_ALL_LISTS_URL, axiosOptions)
   .then((response) => {
     successAll(response);
   })
   .catch((error) => {
     failedAll(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/getall.js